<template>
    <div class="container">
      <slot/>
    </div>
</template>

<script>
    export default {
        name: "container"
    }
</script>

<style lang="scss" scoped>
  @import "src/assets/colors.scss";

  .container {
    margin: 0 auto;
    display: flex;
    padding: 10px;
    border-radius: 20px;
    background: rgba($secondary, 0.2);
    border: $secondary 3px dashed;
  }

  .container button {
    background: none;
    border: none;
    height: 32px;
    padding: 0;

    img {
      height: 32px;
    }
  }
</style>